import { render, staticRenderFns } from "./FaqEdit.vue?vue&type=template&id=77529948&scoped=true&"
import script from "./FaqEdit.vue?vue&type=script&lang=ts&"
export * from "./FaqEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77529948",
  null
  
)

export default component.exports